import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const HeaderWrapper = styled("div")(() => ({
  padding: "24px 32px !important",
  backgroundColor: colors.white,
  borderBottom: `1px solid ${colors.gray200} !important`,
}));

type BreadcrumbItemProps = {
  color?: string;
  hasCursorPointer: boolean;
};

export const BreadcrumbItemSpan = styled("span")(
  ({ color = colors.brandBlue500, hasCursorPointer }: BreadcrumbItemProps) => ({
    color,
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: 0.15,
    cursor: hasCursorPointer ? "pointer" : "default",
  })
);
